(function (Drupal, drupalSettings) {
  Drupal.behaviors.ctardv = {
    attach: function (context, settings) {
      const ctaBanners = context.querySelectorAll(".cta-banner");
      ctaBanners.forEach((banner) => {
        if (!banner.dataset.ctardvProcessed) {
          banner.dataset.ctardvProcessed = "true";

          document.addEventListener("click", function () {
            const ctaContent = document.querySelector(".cta-content");
            if (ctaContent && ctaContent.classList.contains("open")) {
              ctaContent.classList.remove("open");
            }
          });

          const toCopy = document.querySelector(
            "main .cta-banner .cta-content"
          );
          const mainHeader = document.querySelector(".main-header");
          if (toCopy && mainHeader) {
            mainHeader.insertAdjacentElement("afterend", toCopy);
          }

          const ctaBtn = document.querySelector("a.cta-btn");
          if (ctaBtn) {
            ctaBtn.addEventListener("click", function (e) {
              e.preventDefault();
              e.stopPropagation();
              const ctaContent = document.querySelector(".cta-content");
              if (ctaContent) {
                ctaContent.classList.toggle("open");
              }
            });
          }

          const firstTab = document.querySelector(".cta-tabs li:first-child a");
          if (firstTab) {
            firstTab.classList.add("active");
          }

          const firstContent = document.querySelector(
            ".cta-tabs-contents > div:first-child"
          );
          if (firstContent) {
            firstContent.classList.add("active");
          }

          const tabLinks = document.querySelectorAll(".cta-tabs li a");
          tabLinks.forEach((link) => {
            link.addEventListener("click", function (e) {
              e.preventDefault();
              tabLinks.forEach((l) => l.classList.remove("active"));
              link.classList.add("active");
              const toLink = link.getAttribute("data-link");
              const contents = document.querySelectorAll(".cta-tabs-content");
              contents.forEach((content) => content.classList.remove("active"));
              const targetContent = document.querySelector(`.${toLink}`);
              if (targetContent) {
                targetContent.classList.add("active");
              }
            });
          });

          const closeButton = document.querySelector(".cta-content .close");
          if (closeButton) {
            closeButton.addEventListener("click", function (e) {
              e.preventDefault();
              const ctaContent = document.querySelector(".cta-content");
              if (ctaContent) {
                ctaContent.classList.remove("open");
              }
            });
          }

          const hospiListHeaders = document.querySelectorAll(".hospi-list h4");
          hospiListHeaders.forEach((header) => {
            header.addEventListener("click", function () {
              header.parentElement.classList.toggle("open");
            });
          });

          const ctaContent = document.querySelector(".cta-content");
          if (ctaContent) {
            ctaContent.addEventListener("click", function (e) {
              e.stopPropagation();
            });
          }
        }
      });
    },
  };
})(Drupal, drupalSettings);
